// extracted by mini-css-extract-plugin
export default {"head":"PatientSignals_head__ZCKCH","headBtn":"PatientSignals_headBtn__-x35+","btnMonth":"PatientSignals_btnMonth__s5MrX"};